/*import { Helmet } from "react-helmet-async";

const QuizGeneratorMeta = ({ topic, category }) => {
  const baseUrl = "https://quiz.ylyn.org";
  const title = topic
    ? `Quiz on ${topic} | quiz.ylyn.org`
    : "AI Quiz Generator | quiz.ylyn.org";
  const description = topic
    ? `Generate a ${category || "custom"} quiz from a paragraph on ${topic}. Test yourself with multiple choice, true/false, or structured questions.`
    : "Create your own quiz from any text, image, or speech input. Powered by AI. Multiple choice, true/false, and more.";
  const image = `${baseUrl}/assets/social-preview.png`;
  const url = `${baseUrl}/generator`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Quiz",
    "name": title,
    "about": topic || "AI Quiz Generation",
    "educationalLevel": "Beginner",
    "creator": {
      "@type": "Organization",
      "name": "quiz.ylyn.org"
    },
    "inLanguage": "en",
    "audience": {
      "@type": "Audience",
      "educationalRole": "student"
    },
    "learningResourceType": "Quiz"
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={`quiz, ai quiz, ${topic || "education"}, ${category || "general"}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@quizylan" />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default QuizGeneratorMeta; */

import { HelmetProvider } from 'react-helmet-async';
const QuizGeneratorMeta = () => {
  const baseUrl = "https://quiz.ylyn.org";
  const title = `Custom Quiz | quiz.ylyn.org`;
  const description = `Turn any paragraph into a personalized quiz instantly for smarter revision. Test yourself with multiple choice, true/false, or structured questions.`;
  const image = `${baseUrl}/social-preview.png`;
  const url = `${baseUrl}/`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Quiz",
    "name": title,
    "about": "Any data",
    "educationalLevel": "Beginner",
    "creator": {
      "@type": "Organization",
      "name": "quiz.ylyn.org"
    },
    "inLanguage": "en",
    "audience": {
      "@type": "Audience",
      "educationalRole": "student"
    },
    "learningResourceType": "Quiz"
  };

  return (
    <HelmetProvider>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="quiz, ai quiz,Turn any paragraph into a personalized quiz instantly,best revision quiz platform for students,quiz generation for smarter revision,revise,custom quiz, study from quiz, Multiple Choice,Generate quiz from text,Create quizzes from paragraphs,AI quiz generator for teachers/students,How to make a quiz from notes" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@quizylyn" />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
     </HelmetProvider>
  );
};

export default QuizGeneratorMeta;
